import * as React from "react";
 
// importing material UI components
import { useState } from 'react';
import WhatsappTable from './WhatsappTable';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import CreateTemplate from './CreateTemplate';
import { 
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import Search from '@mui/icons-material/Search';

const CreateTemplateManual = (props) => { 
  
  const [componentState, setComponent] = useState(1);
  const [templatesNamesData, setTemplatesNamesData] = useState([]);

  const [charCount, setCharCount] = useState(0);


  return (
    <div className="App">
      <Container maxWidth={false}>
          <>
            <h2 className="heading-title">Create Template</h2>
            <CreateTemplate 
              templatesNamesData={templatesNamesData}
              setComponent={setComponent}
            />
          </>
      </Container>

    </div>
  );
}
export default CreateTemplateManual;
